import { StyleSheet } from 'react-native';
import { widthPercentageToDP as wp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  contentContainerStyleScrollView: {
    alignItems: 'center',
  },
  scrollItemsContainer: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    flexDirection: 'row',
    padding: 10,
  },
  goBackContainerLarge: {
    flex: 0.25,
    alignSelf: 'center',
  },
  goBackContainerSmall: {
    alignSelf: 'center',
    flex: 0.3,
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
    flex: 0.5,
  },
  textTitleLargeCommerce: {
    color: '#807F7F',
  },
  textTitleLargeOrders: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  imageLarge: {
    alignSelf: 'center',
    marginLeft: 35,
    width: 23,
    height: 19,
  },
  imageSmall: {
    alignSelf: 'center',
    marginLeft: 10,
    width: 15,
    height: 12,
  },
  textLarge: {
    flex: 0.2,
    marginLeft: '0.5%',
    color: '#001639',
    alignSelf: 'center',
    fontSize: 16,
    fontWeight: '700',
  },
  textSmall: {
    flex: 0.55,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterspacing: 0.25,
  },
  btnContainer: {
    flex: 0.6,
    alignSelf: 'center',
    justifyContent: 'center',
  },
  iconLarge: {
    flex: 1,
    alignSelf: 'center',
  },
  iconSmall: {
    flex: 0.15,
    alignSelf: 'center',
  },
  inputContainerLarge: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    width: '100%',
    alignSelf: 'center',
    marginBottom: 15,
    padding: 10,
    borderWidth: 1,
  },
  inputContainerSmall: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    width: wp('60%'),
    alignSelf: 'center',
    marginBottom: 15,
    padding: 10,
    borderWidth: 1,
  },
  input: {
    color: '#979797',
    width: '50%',
    paddingLeft: 30,
    fontFamily: 'Circular-Std-Book',
  },
  formContainerPortrait: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '60%',
  },
  formContainerLandscape: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    width: '60%',
  },
  errorText: {
    width: wp('50%'),
    marginBottom: '2%',
    fontSize: 12,
    textAlign: 'center',
    color: '#F00',
  },
  buttonContainerLarge: {
    width: '40%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
    borderRadius: 4,
  },
  buttonContainerSmall: {
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    borderRadius: 4,
  },
  button: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    marginTop: 20,
  },
  buttonTitle: {
    color: '#FFFFFF',
    fontWeight: '500',
    fontSize: 14,
    lineHeight: 16,
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  invalidSubmit: {
    color: '#FF0000',
  },
  phoneInputTextContainerStyle: {
    borderTopRightRadius: 15,
    borderBottomRightRadius: 15,
  },
  touchableCountryCodeContainer: {
    borderRadius: 28,
    marginBottom: 15,
    padding: 10,
    height: 63,
    borderWidth: 1,
    backgroundColor: '#FFFFF',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  countryCodeText: {
    marginTop: 4,
    fontSize: 20,
    color: '#001639',
  },
  iconDownCountryCode: {
    marginTop: 15,
  },
  phoneInputContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 28,
    marginTop: 7,
    padding: 10,
    borderWidth: 1,
  },
  openCountryCodesIcon: {
    marginTop: 8,
    fontSize: 15,
  },
  countryCodephoneInputContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  switchesContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 15,
  },
  switchIsCashContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
    marginLeft: 30,
  },
  switchIsPosnetContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
    marginLeft: 15,
  },
  switch: {
    alignSelf: 'center',
    marginTop: 15,
    width: '20%',
  },
  switchTitle: {
    fontSize: 15,
    color: '#001639',
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0.25,
  },
});
